module.exports = __webpack_public_path__ + "img/is.c79fa464.svg";